import { Component, OnInit } from '@angular/core';
import { AppFilter } from 'src/modules/shared/';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChatService } from 'src/modules/features/admin/services';

interface IAddSubtopicModalContext {
  title: string;
  data: any;
}

@Component({
  selector: 'app-add-subtopic-modal',
  templateUrl: './add-subtopic-modal.component.html',
  styleUrls: ['./add-subtopic-modal.component.scss'],
})
export class AddSubtopicModalComponent implements OnInit {
  baseUrl = environment.API_SERVER;

  pending: boolean;
  success: any;
  error: any;
  filter: AppFilter = new AppFilter();

  data;

  subtopicForm: FormGroup;

  constructor(
    public modal: SuiModal<IAddSubtopicModalContext, void, void>,
    private fb: FormBuilder,
    private chatService: ChatService
  ) {
    this.data = modal.context.data;
    // console.log(this.data, 'extra');
    this.subtopicForm = fb.group({
      subtopic: ['', Validators.required],
    });
  }

  ngOnInit() {}

  submit() {
    if (this.subtopicForm.valid) {
      this.pending = true;
      const body = {
        subtopic: this.subtopicForm.get('subtopic').value,
        description: '',
      };
      const topicId = this.data.topicId;
      this.chatService.addSubTopic({ topicId, body }).subscribe(
        (response) => {
          this.pending = false;
          this.success = 'Subtopic added successfully';
          this.modal.approve();
        },
        (error) => {
          this.error = error.error.errorMessage ?? error.error ?? error;
          this.pending = false;
        }
      );
    }
  }
}

export class AddSubtopicModal extends ComponentModalConfig<
  IAddSubtopicModalContext,
  void,
  void
> {
  constructor(title: string, details: any, size: ModalSize = ModalSize.Mini) {
    super(AddSubtopicModalComponent, { title: title, data: details });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
